import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withRouter } from 'react-router'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import queryString from 'query-string'

import { getToken } from 'utils/token'
import { common as commonApi } from 'redux/modules/api'
import { setFile } from 'redux/modules/files'
// import { IMAGE_SIZES } from 'constants/enums'
import getFileType from 'utils/getFileType'

function decorator(config = {}) {
  return ComposedComponent => {
    @withRouter
    @connect(
      ({ auth, files }) => ({
        user: auth.user,
        files
      }),
      { loadingImage: commonApi.loadingImage, setFile, push }
    )
    class DownloadFile extends PureComponent {
      static propTypes = {
        decoWithCode: PropTypes.bool,
        user: PropTypes.object,
        location: PropTypes.object,
        loadingImage: PropTypes.func.isRequired,
        setFile: PropTypes.func.isRequired,
        files: PropTypes.object.isRequired
      }

      constructor(props) {
        super(props)
        this.state = {
          downloadedFile: null
        }
      }

      // handleDownloadFile = (fileUrl, size = IMAGE_SIZES.default.size) => {
      handleDownloadFile = (fileUrl, { isDirect = false, fileName } = {}) => {
        const { files } = this.props

        if (!__CLIENT__ || files[fileUrl] || !fileUrl) {
          return
        }

        let urlPrefix = '?'

        if (fileUrl.includes('?')) {
          urlPrefix = '&'
        }

        const fileUrlWithParams = `${fileUrl}${urlPrefix}`

        this.props.loadingImage(true)

        if (!isDirect) {
          this.props.setFile({
            fileUrl,
            loading: true
          })
        }

        const headers = new Headers()
        const type = this.mapType(fileUrl)

        headers.append('Authorization', 'Bearer ' + getToken(this.props.user))
        headers.append('Content-Type', type)

        fetch(fileUrlWithParams, { headers })
          .then(response => response.blob())
          .then(blobby => {
            if (isDirect) {
              return this.downloadDirectly(blobby, fileName)
            }

            // const objectUrl = window.URL.createObjectURL(blobby)
            const reader = new FileReader()
            const out = new Blob([blobby], { type })

            reader.onload = () => {
              this.setState({
                downloadedFile: reader.result
              })
              this.props.setFile({
                fileUrl,
                fileLocalUrl: reader.result,
                loading: false,
                type: getFileType(fileUrl),
                name: this.handleGetFileName(fileUrl)
              })
            }
            reader.readAsDataURL(out)
          })
      }

      downloadDirectly = (blob, fileName) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')

        a.href = url
        a.download = fileName
        a.click()
        setTimeout(() => {
          window.URL.revokeObjectURL(url)
          a.remove()
        }, 5000)
      }

      handleDownloadFileCode = file => {
        const { user } = this.props
        const operator = file.includes('?') ? '&' : '?'
        const query = queryString.parse(get(this.props, 'location.search'))
        const authCode = get(query, 'authorizationCode') ||
          get(user, 'blobAccessAuthorizationCode')
        const fileUrl = `${file}${operator}authorizationCode=${authCode}`

        this.setState({
          downloadedFile: fileUrl
        })
        this.props.setFile({
          fileUrl: file,
          fileLocalUrl: fileUrl,
          loading: false,
          type: getFileType(file),
          name: this.handleGetFileName(fileUrl)
        })
      }

      handleGetFileName = fileUrl => {
        if (!fileUrl) {
          return
        }

        const fileName = decodeURIComponent(fileUrl).replace(
          /^.*(\\|\/|\:)/, // eslint-disable-line
          ''
        )

        return fileName.split('.')[0]
      }

      handleBlobToFile = () => {
        // const loadingTask = PDFJS.getDocument({ data: blob })
        // loadingTask.promise.then(pdf => {
        //   console.log('pdf loaded', pdf)
        // })
        // =======
        // if (navigator.msSaveBlob) {
        //   return navigator.msSaveBlob(new Blob([blob], { type }), fileName)
        // }
        // const file = window.URL.createObjectURL(new Blob([blob], { type }))
        // const a = document.createElement('a')
        // a.href = file
        // a.download = fileName
        // document.body.appendChild(a)
        // a.click()
        // window.URL.revokeObjectURL(file)
        // a.remove()
      }

      mapType = fileUrl => {
        let splitted

        if (fileUrl.includes('?')) {
          splitted = fileUrl.substring(0, fileUrl.indexOf('?')).split('.')
        } else {
          splitted = fileUrl.split('.')
        }

        const rawType =
          splitted[splitted.length - 1] &&
          splitted[splitted.length - 1].toLowerCase()

        switch (rawType) {
          case 'png':
            return 'image/png'
          case 'jpg':
          case 'jpeg':
            return 'image/jpeg'
          default:
            return 'application/pdf'
        }
      }

      render() {
        const isWithCode = config.withCode || this.props.decoWithCode

        return (
          <div>
            {this.state.pdf && <img src={this.state.pdf} />}
            <ComposedComponent
              {...this.props}
              onBlobToFile={this.handleBlobToFile}
              onDownloadFile={
                isWithCode
                  ? this.handleDownloadFileCode
                  : this.handleDownloadFile
              }
              downloadedFile={this.state.downloadedFile}
            />
          </div>
        )
      }
    }
    return DownloadFile
  }
}

export default decorator
